/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { EOrigineSuiviListSearch } from './EOrigineSuiviListSearch';
import {
    EOrigineSuiviListSearchFromJSON,
    EOrigineSuiviListSearchFromJSONTyped,
    EOrigineSuiviListSearchToJSON,
} from './EOrigineSuiviListSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';

/**
 * 
 * @export
 * @interface SuiviSearchDto
 */
export interface SuiviSearchDto {
    /**
     * 
     * @type {number}
     * @memberof SuiviSearchDto
     */
    idapprenant?: number;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof SuiviSearchDto
     */
    idrealisateurSuivi?: Int32ListSearch;
    /**
     * 
     * @type {EOrigineSuiviListSearch}
     * @memberof SuiviSearchDto
     */
    origineSuivi?: EOrigineSuiviListSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof SuiviSearchDto
     */
    dateSuivi?: DateSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof SuiviSearchDto
     */
    typeSuivi?: Int32ListSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof SuiviSearchDto
     */
    onlyUserSuivis?: BooleanSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof SuiviSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof SuiviSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SuiviSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof SuiviSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof SuiviSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the SuiviSearchDto interface.
 */
export function instanceOfSuiviSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SuiviSearchDtoFromJSON(json: any): SuiviSearchDto {
    return SuiviSearchDtoFromJSONTyped(json, false);
}

export function SuiviSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SuiviSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'idrealisateurSuivi': !exists(json, 'idrealisateurSuivi') ? undefined : Int32ListSearchFromJSON(json['idrealisateurSuivi']),
        'origineSuivi': !exists(json, 'origineSuivi') ? undefined : EOrigineSuiviListSearchFromJSON(json['origineSuivi']),
        'dateSuivi': !exists(json, 'dateSuivi') ? undefined : DateSearchFromJSON(json['dateSuivi']),
        'typeSuivi': !exists(json, 'typeSuivi') ? undefined : Int32ListSearchFromJSON(json['typeSuivi']),
        'onlyUserSuivis': !exists(json, 'onlyUserSuivis') ? undefined : BooleanSearchFromJSON(json['onlyUserSuivis']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function SuiviSearchDtoToJSON(value?: SuiviSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idapprenant': value.idapprenant,
        'idrealisateurSuivi': Int32ListSearchToJSON(value.idrealisateurSuivi),
        'origineSuivi': EOrigineSuiviListSearchToJSON(value.origineSuivi),
        'dateSuivi': DateSearchToJSON(value.dateSuivi),
        'typeSuivi': Int32ListSearchToJSON(value.typeSuivi),
        'onlyUserSuivis': BooleanSearchToJSON(value.onlyUserSuivis),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

